export const typeDefs = `
directive @defer(label: String, if: Boolean! = true) on FRAGMENT_SPREAD | INLINE_FRAGMENT

type ACCEPT_EVENT_TEAM {
  event_id: Int!
  event_name: String!
  first_name: String!
  last_name: String!
  event_wallet: [Wallet!]
  role: EventOwnerRole!
}

type Account {
  accountName: String
  accountNumber: String
}

type AccountDetails {
  id: UUID!
  event_id: Int!
  walletId: UUID!
  account_number: String!
  bank_name: String!
  currency: Currency!
  beneficiary_name: String!
  swift_code: String!
  country: String!
  city: String!
  bank_address: String
  post_code: String!
  sort_code: String!
}

type ActionCount {
  action: AuditAction!
  count: Int!
}

input addBackStoryReq {
  title: String
  image: String
  role: BackStoryRole!
  story: String!
}

input AddEventPartRequest {
  event_id: Int!
  time: String!
  name: String!
  welcome_msg: String
  address: String!
  address_description: String
  part: String!
  city: String
  state: String
  country: String
  image: String
  geo_position: GeoPositionInput
  programs: [EventPartProgramInput]
}

input AddEventVendorRequest {
  event_id: Int!
  name: String
  role: String!
  email: String
  phone_number: String!
  instagram_handle: String
  facebook: String
  twitter: String
  image: String
}

input AddOwnerRequest {
  event_id: Int!
  user_id: Int!
  admin: Boolean
}

input AddToInviteListReq {
  first_name: String!
  last_name: String!
  other_name: String
  title: String
  phone: String!
  category_id: Int
  email: String
  slots: Int
}

input addWeddingPartyReq {
  first_name: String!
  last_name: String!
  nickname: String
  role: String!
  image_url: String
  story: String
  order_index: Float
}

type Album {
  id: String!
  name: String!
  event_id: UUID!
  description: String
  created_by: UUID
  Media(page: Int, page_size: Int): PaginatedAlbumMedia!
  creator: Creator
  created_at: Time!
  updated_at: Time
}

type AlbumMedia {
  id: String!
  name: String
  url: String
  tags: [AlbumMediaTag]!
  type: String
  meta: MediaMeta
  private: Boolean
  user_id: UUID
  event_id: UUID
  album_id: UUID
  album: Album
  likes: Int
  order_index: Float
  user_type: UserTypeEnum
  created_at: Time
  updated_at: Time
}

enum AlbumMediaTag {
  bride
  groom
  family
  hero_page
  couple
  showcase
  friends
  bridesmaid
  best_man
  others
}

enum ApplicantTypeEnum {
  GROOM
  BRIDE
}

type Aseobi {
  id: UUID!
  event_id: UUID!
  category_id: UUID
  name: String!
  description: String
  status: String!
  payment_provider: String
  sub_account_id: String
  sub_account_code: String
  contacts: [AseobiContact]
  created_at: Time!
  updated_at: Time
  aseobi_orders: [AseobiOrder]
}

type AseobiAttire {
  id: UUID!
  event_id: UUID!
  aseobi_id: UUID!
  name: String!
  note: String
  images: [String!]
  description: String
  currency_iso: String!
  price_per_yard: Float!
  fee_percentage: Float!
  total_price_per_yard: Float!
  yards_available: Int!
  yards_sold: Int!
  active: Boolean!
  created_at: Time!
  updated_at: Time
  aseobi: Aseobi!
  aseobi_orders: [AseobiOrder]
}

input AseobiAttireInput {
  aseobi_id: UUID!
  name: String!
  note: String
  images: [String!]
  description: String
  currency_iso: Currency!
  price_per_yard: Float!
  yards_available: Int!
  active: Boolean
}

type AseobiAttirePresignURLResponse {
  upload_url: String!
  file_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
  attire_id: UUID!
}

type AseobiContact {
  note: String
  email: String
  phone_number: String!
}

type AseobiOrder {
  id: UUID!
  provider: String!
  provider_reference: String!
  event_id: UUID!
  aseobi_id: UUID!
  aseobi_attire_id: UUID!
  user_id: UUID!
  user: User!
  note: String
  contact_email: String!
  contact_phone_number: String!
  delivery_address: String
  quantity: Int!
  yards: Int!
  price_per_yard: Float!
  fee_percentage: Float!
  total_price: Float!
  created_at: Time
}

input AseobiPaymentMetadataRequest {
  payment_provider: String!
  user_id: UUID!
  contact_email: String!
  contact_phone: String!
  delivery_address: String
  note: String
  currency: Currency!
  aseobi_id: UUID!
  attires: [AseobiPaymentMetadataRequestAttire!]!
}

input AseobiPaymentMetadataRequestAttire {
  aseobi_id: UUID!
  attire_id: UUID!
  yards: Int!
  quantity: Int!
}

type AsoebiPaymentMetaData {
  inawo_product: String!
  event_id: UUID!
  user_id: UUID!
  aseobi_id: UUID!
  note: String
  contact_email: String!
  contact_phone_number: String!
  delivery_address: String
  payment_reference: String!
  payment_provider: String!
  sub_account_id: String!
  sub_account_code: String!
  hash: String!
  currency: Currency!
  split_percentage: Float!
  transaction_charge: Float!
  total_amount: Float!
  timestamp: Time!
  attires: [AsoebiPaymentMetadataAttire!]!
  custom_fields: [PaymentMetaDataCustomField!]!
}

type AsoebiPaymentMetadataAttire {
  order_id: UUID!
  attire_id: UUID!
  aseobi_id: UUID!
  price_per_yard: Float!
  fee_percentage: Float!
  yards: Int!
  total_price_per_quantity: Float!
  quantity: Int!
  total_price: Float!
}

enum AsoebiStatus {
  draft
  active
  archived
}

input AttachDomainInput {
  domain_id: UUID!
  event_id: UUID!
}

enum AuditAction {
  CREATE
  UPDATE
  DELETE
  VIEW
  INVITE
  RSVP
  CHECK_IN
  PAYMENT
  MESSAGE
  UPLOAD
  RESERVE
  SEND
  SHARE
  EXPORT
  LOGIN
  LOGOUT
}

input AuditFilter {
  event_id: UUID
  user_id: UUID
  action: AuditAction
  resource: AuditResource
  resource_id: String
  success: Boolean
  start_date: Time
  end_date: Time
  search_term: String
}

type AuditLog {
  id: UUID!
  event_id: UUID!
  user_id: UUID!
  user_email: String!
  user_name: String
  user_role: String
  action: AuditAction!
  resource: AuditResource!
  resource_id: String
  resource_name: String
  summary: String!
  details: Map
  ip_address: String
  user_agent: String
  success: Boolean!
  error_message: String
  created_at: Time!
}

enum AuditResource {
  EVENT
  INVITATION
  GUEST
  CATEGORY
  VENDOR
  TEAM_MEMBER
  GALLERY
  ALBUM
  MEDIA
  WISH_LIST
  MESSAGE
  BACK_STORY
  EVENT_PART
  TABLE_RESERVATION
  FAQ
  ASEOBI
  PAYMENT
  USER
}

type AuditStats {
  total_actions: Int!
  unique_users: Int!
  action_counts: [ActionCount!]!
  resource_counts: [ResourceCount!]!
  recent_actions: [AuditLog!]!
  top_users: [UserActivity!]!
}

type AuthResponse {
  refresh_token: String!
  refresh_expiry: Time
  access_token: String!
  access_expiry: Time
  user: User
}

type AvailableCurrency {
  """e.g Dollar, Naira"""
  name: String!

  """e.g $, ₦"""
  symbol: String

  """e.g USD, NGN"""
  currency: Currency!
}

type BackStory {
  id: Int!
  uuid: String!
  title: String
  event_id: Int!
  role: BackStoryRole!
  image: String
  story: String!
  created_at: Time
  updated_at: Time
}

type BackStoryPresignedURLResponse {
  upload_url: String!
  file_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
}

enum BackStoryRole {
  Bride
  Groom
  Both
}

type Bank {
  id: Int
  code: String
  name: String
}

type BankDetail {
  bank_name: String!
  account_number: String!
  account_name: String!
}

type Banks {
  id: Int
  createdAt: String
  updatedAt: String
  name: String
  slug: String
  code: String
  long_code: String
  gateway: Int
  active: Boolean
  is_deleted: Boolean
}

type Beneficiary {
  id: UUID!
  user_id: UUID!
  payment_processor: String!
  account_name: String!
  bank_name: String!
  account_number: String!
  currency: Currency!
  country: String!
  personal: Boolean!
  meta_data: Map!
  last_used_at: Time
  created_at: Time!
  updated_at: Time
}

type Bouncer {
  id: UUID!
  event_id: UUID!
  first_name: String!
  last_name: String!
  phone: String!
  email: String!
  created_at: Time
}

type BouncerAuthResponse {
  auth_response: AuthResponse!
  event: Event!
  bouncer: Bouncer!
}

enum CacheControlScope {
  PUBLIC
  PRIVATE
}

type Category {
  id: Int!
  event_id: Int!
  name: String!
  message: String
  created_at: Time
  updated_at: Time
}

enum Channel {
  email
  sms
  whatsapp
  rcs
  imessage
}

input CheckInGuestRequest {
  bouncer_id: UUID!
  invitation_id: UUID!
  note: String
  slot: Int
}

input ContactInput {
  note: String
  email: String
  phone_number: String!
}

input createDocumentTypeInput {
  name: String!
  description: String
  stage: Int!
  applicant_type: ApplicantTypeEnum!
}

type CreateEventResponse {
  id: Int!
  name: String!
  created_at: Time!
  updated_at: Time
}

input CreateFAQInput {
  event_id: UUID!
  event_part_id: UUID
  question: String!
  answer: String!
  order_index: Int
  is_active: Boolean
}

input CreateInvitationReq {
  event_id: Int!
  category_id: Int!
  template_url: String
}

input createRegistryInput {
  name: String!
  address: String!
  city: String!
  state: String!
  phone_numbers: [String!]!
  images: [String!]
  emails: [String!]!
}

input CreateStreamer {
  inviteListId: Int!
  eventId: Int!
  streamer_name: String!
  streamer_email: String
  streamer_phone: String!
}

type Creator {
  user_id: UUID
  username: String
  image: String
}

enum Currency {
  ngn
  usd
  gbp
  eur
  ghs
  gnf
  kes
  mwk
  mad
  sll
  std
  rwf
  xaf
  xof
  zar
  tzs
  ugx
  zmw
  egp
}

input DetachDomainInput {
  domain_id: UUID!
  reason: String
}

enum DocumentStatusEnum {
  PENDING
  APPROVED
  REJECTED
  SUBMITTED
}

type DojahBankInfo {
  name: String!
  code: String!
}

type Domain {
  id: UUID!
  user_id: UUID!
  event_id: UUID
  domain_name: String!
  status: DomainStatus!
  purchase_date: Time
  expiry_date: Time
  renewal_price: Float!
  purchase_price: Float!
  currency: String!
  auto_renew: Boolean!
  dns_configured: Boolean!
  created_at: Time!
  updated_at: Time
  user: User
  event: Event
  transaction: TransactionV1
}

type DomainAvailabilityResponse {
  available: Boolean!
  price: Float!
  currency: String!
  premium: Boolean!
}

input DomainContactInput {
  first_name: String!
  last_name: String!
  email: Email!
  phone: E164!
  address: String!
  city: String!
  state: String!
  postal_code: String!
  country: String!
}

type DomainHistory {
  id: UUID!
  domain_id: UUID!
  event_id: UUID
  attached_at: Time!
  detached_at: Time
  attached_by: UUID!
  detached_by: UUID
  detach_reason: String
  domain: Domain
  event: Event
  attached_by_user: User
  detached_by_user: User
}

type DomainListResponse {
  domains: [Domain!]!
  total: Int!
}

type DomainPricing {
  tld: String!
  register_price: Float!
  renewal_price: Float!
  transfer_price: Float!
  currency: String!
  last_updated: Time!
}

enum DomainStatus {
  ACTIVE
  PENDING
  EXPIRED
  FAILED
  DETACHED
}

scalar E164

scalar Email

input EstimateInvitationCostReq {
  pending: Boolean!
  all: Boolean!
  number_of_guests: Int!
  channel: Channel!
}

type EstimateInvitationCostResp {
  currency: Currency!
  usd_rate: Float!
  rate: Float!
  cost: Float!
}

type Event {
  id: Int!
  uuid: UUID!
  name: String!
  template_id: String!
  luxe: Boolean!
  hero_image: String
  hero_image_thumbnail: String
  pass_image: String
  logo: String
  wallet_created: Boolean
  hash_tag: String

  """deprecated"""
  token: String
  slug: String
  toast: String
  welcome_msg: String
  created_at: Time
  updated_at: Time
  date: String
  event_wallet: [Wallet]

  """deprecated"""
  event_owners: [EventOwner!]!
  event_type: EventType
  event_parts: [EventPart!]
  event_preference: EventPreference
  invite_credit: InviteCredit!
  is_admin: Boolean!
  card: InvitationCard
  enabled_currencies: [Currency]
  is_invited: Boolean!
  supported_currencies: [Currency!]!
}

type EventOwner {
  id: Int!
  user_id: Int!
  event_id: Int!
  admin: Boolean
  role: String
  user: User
  created_at: Time
  updated_at: Time
}

enum EventOwnerRole {
  bride
  groom
  planner
  bouncer
}

type EventPart {
  id: Int!
  uuid: UUID!
  event_id: Int!
  name: String!
  part: String!
  time: Time!
  welcome_msg: String
  address: String!
  city: String
  state: String
  country: String
  map_coordinate: String
  image: String
  geo_position: GeoPosition
  programs: [EventPartProgram]
  created_at: Time
  updated_at: Time
  num_table_reservations: Int!
  num_seat_reservations: Int!
}

type EventPartProgram {
  index: Int!
  name: String!
  attr: Map
}

input EventPartProgramInput {
  index: Int!
  name: String!
  attr: Map
}

type EventPlan {
  event_id: Int!
  event_details: Boolean!
  invitation_card: Boolean!
  categories: Boolean!
  build_invite_list: Boolean!
  send_out_invites: Boolean!
  add_wishlist: Boolean!
  website_template: Boolean!
  add_back_story: Boolean!
  upload_pictures: Boolean!
  add_event_vendors: Boolean!
  wallet_pin_set: Boolean!
  add_foreign_account: Boolean!
  add_live_hall: Boolean!
}

type EventPreference {
  id: UUID!
  event_id: UUID!
  food: Boolean
  ads: Boolean
  asoebi_selection: Boolean
  gifts: Boolean
  store: Boolean
  vendor_store: Boolean
  reservation: Boolean
  access_control: Boolean
  dress_code: Boolean
  map: Boolean
  smart_send: Boolean
  private: Boolean
  live_hall: Boolean
  guest_pov_default_public: Boolean
  created_at: Time
  updated_at: Time
}

type EventSiteTemplate {
  id: Int!
  event_type: String!
  image: String!
  description: String!
  created_by: String!
  contact: String!
  created_at: Time
  updated_at: Time
}

type EventTask {
  id: UUID!
  event_id: Int!
  eventUUID: UUID!
  name: String!
  description: String!
  done: Boolean
  created_at: Time
  updated_at: Time
}

type EventTemplates {
  id: String!
  currency: Currency!
  fee: Float!
}

type EventType {
  id: Int!
  name: String!
  description: String!
}

type EventVendor {
  id: Int!
  event_id: Int!
  name: String
  role: String
  email: String
  phone_number: String!
  instagram_handle: String
  facebook: String
  twitter: String
  image: String
  created_at: Time
  updated_at: Time
}

enum ExportFormat {
  JSON
  CSV
}

type FAQ {
  id: UUID!
  event_id: UUID!
  event_part_id: UUID
  question: String!
  answer: String!
  order_index: Int
  is_active: Boolean!
  created_at: Time!
  updated_at: Time
}

input FAQFilter {
  event_part_id: UUID
  is_active: Boolean
  page: Int
  pageSize: Int
}

input FAQOrderInput {
  id: UUID!
  order_index: Int!
}

type FAQResponse {
  success: Boolean!
  message: String
  faq: FAQ
}

enum FileUploadPermissionEnum {
  admin
  guest
  all
}

input foreignAccountDetails {
  event_id: Int!
  walletId: String!
  account_number: String!
  bank_name: String!
  currency: Currency!
  beneficiary_name: String!
  swift_code: String!
  country: String!
  city: String!
  bank_address: String
  post_code: String!
  sort_code: String!
}

enum Gender {
  female
  male
}

type GeneralInvitationResp {
  event: Event
  invitation_card: InvitationCard
}

type GeneralInviteResp {
  auth_response: AuthResponse!
  event: Event!
  invitation: InvitationList!
  invitation_card: InvitationCard!
}

type GeoPosition {
  geo_position_id: String
  latitude: String
  longitude: String
}

input GeoPositionInput {
  geo_position_id: String
  latitude: Float
  longitude: Float
}

type Gift {
  id: UUID!
  event_id: UUID!
  wallet_id: UUID!
  user_id: UUID
  wish_list_item_id: UUID
  creditor_alias: String
  narration: String!
  note: String
  payment_provider: String!
  payment_provider_reference: String!
  currency_iso: Currency!
  amount: Float!
  fee: Float!
  total_amount: Float!
  user: User
  created_at: Time!
}

type GiftCard {
  id: UUID!
  code: String!
  status: String!
  created_at: Time!
  expires_at: Time!
  purchaser_email: String!
  purchaser_name: String!
  recipient_email: String!
  recipient_name: String!
  message: String!
  currency: Currency!
  original_amount: Float!
  is_redeemed: Boolean!
}

type GiftCardPaymentMetaData {
  inawo_product: String!
  purchaser_email: String!
  purchaser_name: String!
  recipient_email: String!
  recipient_name: String!
  message: String!
  amount: Float!
  luxe_discount_percentage: Float!
  payment_reference: String!
  payment_provider: String!
  currency_iso: String!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

type GiftPaymentMetaData {
  inawo_product: String!
  gift_id: UUID!
  event_id: UUID!
  user_id: UUID
  wish_list_item_id: UUID
  note: String
  full_name: String
  contact_email: String
  contact_phone_number: String
  payment_reference: String!
  payment_provider: String!
  sub_account_id: String!
  sub_account_code: String!
  currency_iso: String!
  split_percentage: Float!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

input GiftPaymentMetadataRequest {
  payment_provider: String!
  user_id: UUID
  event_id: UUID!
  contact_email: String
  contact_phone: String
  note: String
  full_name: String
  currency: Currency!
  wish_list_item_id: UUID
  currency_iso: Currency!
  amount: Float!
}

type GiftsWithPagination {
  meta: Pagination
  gifts: [Gift]
}

input guestArrangement {
  guest_id: UUID!
  table: String!
  seat: String!
}

type GuestPerCategory {
  category_id: Int!
  category_name: String!
  message: String
  num_guest: Int
}

type InawoAssistantPaymentMetaData {
  inawo_product: String!
  event_id: UUID!
  user_id: UUID!
  full_name: String!
  contact_email: String!
  contact_phone_number: String
  payment_reference: String!
  payment_provider: String!
  currency_iso: String!
  amount: Float!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

type InawoPassProgress {
  in_progress: Boolean!
  total_sent: Int!
  total_guest: Int!
}

type InitiateLuxeGiftCardPaymentResponse {
  success: Boolean!
  message: String!
  payment_reference: String
  payment_link: String
}

input initiatePaymentInput {
  event_id: Int!
  currency: Currency!
  amount: Float!
  is_cash_gift: Boolean!
  item_uuid: String
  creditor_alias: String!
  email: String
  phone: String
}

type InitiatePaymentResponse {
  reference: String!
  authorization_url: String!
  client_secret: String!
}

type InvitationCard {
  id: Int
  event_id: Int
  template: String
  template_id: UUID
  card_template: INVITATION_CARD_TEMPLATE
  created_at: Time
  updated_at: Time
}

type InvitationCardPresignedURLResponse {
  upload_url: String!
  file_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
}

type InvitationCardSchemaField {
  id: String!
  name: String!
  default_value: String
  required: Boolean!
  regrex: String
  data_type: String!
  options: [String!]
}

type InvitationCardSchemaFields {
  fields: [InvitationCardSchemaField!]!
}

type INVITATION_CARD_TEMPLATE {
  id: UUID!
  name: String!
  component_url: String
  thumbnail_url: String!
  schema_fields: InvitationCardSchemaFields!
  luxe: Boolean!
  created_at: Time
  updated_at: Time
}

type InvitationList {
  id: Int!
  uuid: UUID!
  event_id: Int!
  inawo_pass_image: String
  event_uuid: UUID!
  first_name: String!
  other_name: String
  last_name: String!
  title: String
  phone: String!
  email: String
  status: InvitationListDeliveryStatus
  activities: [InvitationListActivity]
  CheckInAt: Time
  sent: Boolean!
  category_id: Int
  category: Category
  slots: Int
  slots_used: Int
  selfie: String
  qr_code: String
  rsvp_status: String
  created_at: Time
  updated_at: Time
}

type InvitationListActivity {
  timestamp: Time!
  action: String!
  authorization: Map
  note: String
}

type InvitationListDeliveryStatus {
  whatsapp: InvitationListDeliveryTime
  sms: InvitationListDeliveryTime
  email: InvitationListDeliveryTime
}

type InvitationListDeliveryTime {
  sent_at: Time
  delivered_at: Time
  read_at: Time
  failed_at: Time
  failure_reason: String
}

enum invitationListFilter {
  all
  sent
  not_sent
}

type InvitationListResponse {
  total: Int!
  invitationList: [InvitationList!]
}

enum InvitationListRsvpStatus {
  yes
  no
  maybe
  pending
}

type InviteCredit {
  whatsapp: Int!
}

type InviteFeePaymentMetaData {
  inawo_product: String!
  event_id: UUID!
  user_id: UUID!
  amount: Float!
  currency_iso: Currency!
  payment_reference: String!
  payment_provider: String!
  channel: Channel!
  count: Int!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

input IsStreamerInput {
  eventId: Int!
  userId: Int!
}

type KYCRecord {
  id: UUID!
  user_id: UUID!
  status: String!
  country_iso: String
  bank_details: [BankDetail]
  created_at: Time!
  updated_at: Time
}

type KycResponse {
  eligible: Boolean!
  message: String!
  widget_id: String!
  app_id: String!
}

type ListMeta {
  total: Int
  skipped: Int
  perPage: Int
  page: Int
  pageCount: Int
}

type LiveComment {
  id: String!
  username: String!
  kind: LiveCommentKind!
  comment: String!
  created_at: Time!
  updated_at: Time
}

type LiveCommentEvent {
  live_schedule_id: String!
  created_at: String!
  username: String!
  kind: LiveCommentKind!
  comment: String!
}

enum LiveCommentKind {
  regular
  greeting
}

type LiveSchedule {
  id: UUID!
  event_uuid: UUID!
  event_part_uuid: UUID!
  link: String!
  time: Time!
  created_at: Time
  updated_at: Time
  event: Event!
  event_part: EventPart!
}

type LiveSprayEvent {
  live_schedule_id: String!
  created_at: String!
  username: String!
  sprays: [spray!]!
  currency: Currency!
}

input LoginRequest {
  username: String!
  password: String!
}

type LuxeDescription {
  currency: Currency!
  discount_percentage: Float!
  discounted_amount: Float!
  undiscounted_amount: Float!
  notes: String!
}

type LuxePaymentMetaData {
  inawo_product: String!
  event_id: UUID!
  user_id: UUID!
  full_name: String!
  amount_before_discount: Float!
  discount_amount_applied: Float!
  discount_percentage_applied: Float!
  amount_after_discount: Float!
  payment_reference: String!
  payment_provider: String!
  currency_iso: String!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

scalar Map

type MapObject {
  Key: String!
  Value: String!
}

input MapObjectInput {
  Key: String!
  Value: String!
}

type MarriageApplication {
  id: UUID!
  registry_payment_history_id: UUID!
  event_id: UUID
  groom_id: UUID
  groom: RegistryApplicant
  bride_id: UUID
  bride: RegistryApplicant
  registry_id: UUID
  date: Time
  status: MarriageApplicationStatusEnum
  can_change_date: Boolean!
  registry: Registry!
  registry_documents: [RegistryDocument!]!
  registry_payment_history(filter: RegistryPaymentHistoryFilter!): [RegistryPaymentHistory!]!
  reason: String
  applied_at: Time
  approved_at: Time
  rejected_at: Time
  approved_by_id: UUID
  rejected_by_id: UUID
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

input MarriageApplicationFilter {
  after: Time
  before: Time
  date: Time
  status: MarriageApplicationStatusEnum
}

enum MarriageApplicationStatusEnum {
  PAYMENT_COMPLETED
  DOCUMENT_SUBMITTED
  DOCUMENT_APPROVED
  DOCUMENT_REJECTED
  DATE_SUBMITTED
  DATE_APPROVED
  DATE_REJECTED
}

input MediaFilter {
  album_id: String
  no_album: Boolean
  tags: [AlbumMediaTag!]
  page: Int
  pageSize: Int
}

type MediaMeta {
  s3_url: String
  height: Int
  width: Int
}

type MediaPresignURLResponse {
  upload_url: String!
  file_uri: String!
  thumbnail_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
  media_id: UUID!
}

type Message {
  id: Int!
  event_id: Int!
  user_id: Int!
  user: User
  content: String
  reply: String
  status: Boolean!
  created_at: Time
  updated_at: Time
}

type MessageResponse {
  total: Int!
  messages: [Message!]
}

type Meta {
  next: Int
  page: Int
  pageSize: Int
}

type Mutation {
  hiUser(name: String!): String!
  signupByPhoneNumber(input: SignUpRequest!): Boolean
  login(input: LoginRequest!): AuthResponse!
  logout: String!
  resetPassword(OTP: String!, password: String!, phone: String!): String!
  changePassword(oldPassword: String!, newPassword: String!): String
  verifyPhone(otp: String!, phone: String!): AuthResponse!
  resendVerifyPhoneOTP(phone: String!): Boolean
  sendForgetPasswordOTP(phone: String!): String!
  updateUserProfile(input: UpdateUserProfileRequest!): User
  initiateKyc(currency: Currency!): KycResponse
  updateUserBankDetails(event_id: UUID!, input: UpdateBankDetailsRequest!): Boolean
  SET_UP_PAYSTACK_SUBACCOUNT(event_id: UUID!, input: UpdateBankDetailsRequest!): Boolean
  setUpFlutterwaveSubaccount(event_id: UUID!, input: UpdateBankDetailsRequest!): Boolean
  CREATE_STRIPE_CONNECT_ACCOUNT(event_id: UUID): StripeConnectOnboardingResponse
  GET_STRIPE_CONNECT_ACCOUNT_STATUS: StripeConnectStatusResponse
  CREATE_STRIPE_CONNECT_LOGIN_LINK: String
  attachStripeConnectToEvent(event_id: UUID!): Boolean
  checkDomainAvailability(domain_name: String!): DomainAvailabilityResponse!
  registerDomain(input: RegisterDomainInput!): Domain!
  attachDomain(input: AttachDomainInput!): Domain!
  detachDomain(input: DetachDomainInput!): Domain!
  createEvent(name: String!, event_type_id: Int!, hashTag: String, welcomeMsg: String, role: String, template_id: String): Event
  updateEvent(event_id: Int!, name: String, event_type_id: Int, hashTag: String, toast: String, welcomeMsg: String, template_id: String, logo: String): Event
  deleteEvent(event_id: Int!): String
  selectTemplate(req: SelectTemplateReq!): String!
  addEventPart(input: AddEventPartRequest!): EventPart!
  updateEventPart(input: UpdateEventPartRequest!): EventPart!
  deleteEventPart(event_id: Int!, partId: Int!): String!
  updateEventPreference(input: UpdateEventPreferenceRequest): EventPreference
  updateEventSlug(event_id: Int!, slug: String!): Event
  ATTACH_EVENT_WALLET_TO_SUBACCOUNT(event_id: UUID!, currency: Currency!): Boolean
  DETACH_EVENT_WALLET_FROM_SUBACCOUNT(event_id: UUID!, currency: Currency!): Boolean
  createGuestCategory(event_id: Int!, name: String!, message: String): Category!
  createMultipleGuestCategories(event_id: Int!, names: [String!]): [Category!]
  updateGuestCategory(event_id: Int!, categoryId: Int!, name: String!, message: String): Category!
  deleteGuestCategory(event_id: Int!, categoryId: Int!): String!

  """
  Add a list of guests to the invitation list. It returns the any already guests.
  """
  addToInviteList(event_id: Int!, invite_list: [AddToInviteListReq!]!): [InvitationList]

  """Add a single guest to the invitation list."""
  addGuestToInviteList(event_id: Int!, guest: AddToInviteListReq!): String
  GeneralInviteListReq(event_token: String!, args: AddToInviteListReq!): GeneralInviteResp!
  authenticateInviteLink(inviteToken: String!, event_id: Int!): GeneralInviteResp!
  signupByInviteLink(eventId: Int!, inviteToken: String!): GeneralInviteResp
  resetGeneralInviteToken(event_id: UUID!): String
  generateInvitationSelfiePreSignedUrl(event_id: UUID!, invitation_id: UUID!, mediaType: String!): SelfiePresignURLResponse!
  GENERATE_BACKSTORY_PRESIGNED_URL(event_id: UUID!, mediaType: String!): BackStoryPresignedURLResponse!
  VERIFY_INVITATION_SELFIE_UPLOAD(event_id: UUID!, invitation_id: UUID!, fileUri: String!): String!
  updateInviteList(event_id: Int!, invite_list: [UpdateInviteListReq!]!): String
  removeFromInvitationList(event_id: Int!, invitation_list_ids: [Int!]!): String!
  updateInvitationCard(event_id: Int!, template: String!): InvitationCard
  GENERATE_INVITATION_CARD_PRESIGNED_URL(event_id: UUID!, mediaType: String!): InvitationCardPresignedURLResponse!
  VERIFY_INVITATION_CARD_UPLOAD(event_id: UUID!, fileUri: String!): String!
  sendInvitations(event_id: UUID!, req: SendInviteReq!): SendInvitationsResponse
  estimateInvitationCost(event_id: UUID!, req: EstimateInvitationCostReq!): EstimateInvitationCostResp!
  updateRsvpStatus(event_id: Int!, status: String!): Boolean!
  addEventTeamMember(team: TeamMember!): Boolean
  acceptEventTeam(token: String!): ACCEPT_EVENT_TEAM
  removeTeamMember(event_id: Int!, owner_id: Int!): Boolean
  addEventVendor(input: AddEventVendorRequest!): EventVendor
  updateEventVendor(input: UpdateEventVendorRequest!): EventVendor
  removeEventVendor(event_id: Int!, vendorId: Int!): String
  createMessage(event_id: Int!, content: String!): String!
  updateMessage(message_id: Int!, content: String!): Message!
  replyMessage(event_id: Int!, message_id: Int!, reply: String!): String
  updateMessageStatus(event_id: Int!, messages: [UpdateMessageStatusReq!]!): String!
  deleteMessageById(event_id: Int!, message_id: Int!): String!
  addWishListItem(event_id: Int!, name: String!, image: String!, amount: Float!, currency: Currency): WishListItem
  updateWishListItem(event_id: Int!, itemId: Int!, name: String, image: String, amount: Float, currency: Currency): WishListItem
  appreciateGift(event_id: Int!, walletId: String!, transactionId: String!, appreciation: String!): Boolean
  broadcastAppreciation(event_id: Int!, appreciation: String!): Boolean
  deleteWishListItem(event_id: Int!, itemId: Int!): String!
  addBackStory(event_id: Int!, input: addBackStoryReq!): BackStory
  updateBackStory(event_id: Int!, input: updateBackStoryReq!): BackStory
  deleteBackStory(event_id: Int!, id: Int!): String
  addWeddingParty(event_id: UUID!, input: addWeddingPartyReq!): WeddingParty
  updateWeddingParty(event_id: UUID!, input: updateWeddingPartyReq!): WeddingParty
  deleteWeddingParty(event_id: UUID!, id: UUID!): String
  GENERATE_WEDDING_PARTY_PRESIGNED_URL(event_id: UUID!, mediaType: String!): WeddingPartyPresignedURLResponse!
  addCustomMyPlanTask(event_id: Int!, taskName: String!, description: String!): EventTask!
  updateDoneStatus(eventID: Int!, task_id: UUID!, isDone: Boolean!): Boolean
  editCustomMyPlanTask(event_id: Int!, task_id: UUID!, taskName: String!, description: String!): EventTask!
  deleteCustomMyPlanTask(event_id: Int!, task_id: UUID!): Boolean
  setHeroImage(event_id: Int!, image: String!): String
  removeHeroImage(event_id: Int!): String
  setPassImage(event_id: UUID!, image: String!): Boolean
  removePassImage(event_id: UUID!): Boolean
  shrinkLink(event_id: UUID!, link: String!): String
  autoSendInawoPass(event_id: UUID!): Boolean
  sendBouncerSecret(event_id: UUID!, bouncer_email: String!): Boolean
  authenticateBouncerSecret(event_id: UUID!, bouncer_email: String!, secret: String!): BouncerAuthResponse!
  checkInGuest(event_id: UUID!, request: CheckInGuestRequest!): Boolean!
  createAseobi(event_id: UUID!, name: String!, category_id: UUID, description: String, contact: ContactInput): UUID!
  updateAseobi(id: UUID!, event_id: UUID!, category_id: UUID, name: String, status: AsoebiStatus, description: String, contact: ContactInput, currency_iso: Currency): UUID!
  deleteAseobi(event_id: UUID!, aseobi_id: UUID!): String!
  addAseobiAttire(event_id: UUID!, input: AseobiAttireInput!): UUID!
  updateAseobiAttire(event_id: UUID!, id: UUID!, input: AseobiAttireInput!): UUID!
  deleteAseobiAttire(event_id: UUID!, aseobi_attire_id: UUID!): String!
  generateAseobiAttirePresignUrl(event_id: UUID!, attire_id: UUID!, mediaType: String!): AseobiAttirePresignURLResponse!
  verifyAseobiAttireUpload(event_id: UUID!, replace: Boolean!, attire_id: UUID!, fileUri: String!): String!
  deleteSeatReservation(event_id: UUID!, event_part_id: UUID!, reservation_id: UUID!): Boolean
  attachAseobiPayment(event_id: UUID!, aseobi_id: UUID!, currency_iso: Currency!): UUID!
  createFAQ(input: CreateFAQInput!): FAQResponse!
  updateFAQ(input: UpdateFAQInput!): FAQResponse!
  deleteFAQ(id: UUID!, event_id: UUID!): FAQResponse!
  bulkCreateFAQs(event_id: UUID!, faqs: [CreateFAQInput!]!): [FAQ!]!
  reorderFAQs(event_id: UUID!, faq_orders: [FAQOrderInput!]!): [FAQ!]!
  createAlbum(event_id: UUID!, name: String!, description: String): Album
  updateAlbum(event_id: UUID!, album_id: UUID!, name: String, description: String): Album
  deleteAlbum(event_id: UUID!, album_id: UUID!): String
  addMediaToAlbum(event_id: UUID!, album_id: UUID!, tags: [AlbumMediaTag!], media_ids: [String!]!): String!
  updateMedia(album_id: UUID, event_id: UUID!, media_id: UUID!, name: String, url: String, tags: [AlbumMediaTag], type: String, order_index: Float): AlbumMedia
  UPDATE_MEDIA_ORDER(event_id: UUID!, media_id: UUID!, order_index: Float!): AlbumMedia
  addMedia(event_id: UUID!, album_id: UUID, name: String, url: String!, tags: [AlbumMediaTag!]!, type: String): AlbumMedia!
  deleteMedia(event_id: UUID!, media_id: UUID!): String
  bulkDeleteMedia(event_id: UUID!, media_id: [UUID!]!): String
  GET_MEDIA_PRESIGNED_URL(event_id: UUID!, mediaType: String!): MediaPresignURLResponse!
  VERIFY_MEDIA_UPLOAD(event_id: UUID!, url: String!, tags: [AlbumMediaTag!]!): String!
  verifyAnonymousGuestMediaUpload(name: String!, device_id: String, event_id: UUID!, url: String!, tags: [AlbumMediaTag!]!): String!
  likeAlbum(event_id: UUID!, album_id: UUID!): String
  unlikeAlbum(event_id: UUID!, album_id: UUID!): String
  likeMedia(event_id: UUID!, media_id: UUID!): String!
  unlikeMedia(event_id: UUID!, media_id: UUID!): String!
  helloLiveEvents: Boolean!

  """STREAMERS"""
  addStreamerFromInviteList(args: [CreateStreamer!]!): Boolean
  removeStreamerFromInviteList(streamerId: String!): Boolean
  updateStreamer(args: UPDATE_STREAMER!): Boolean
  startStreaming(streamerId: String!): Boolean!
  stopStreaming(streamerId: String!): Boolean!
  comment(UserName: String!, liveScheduleID: String!, kind: LiveCommentKind!, comment: String!): String
  createLiveSchedule(eventUuid: String!, eventPartUuid: String!, link: String!, date: String!, time: String!): String
  updateLiveSchedule(id: String!, link: String, date: String, time: String): String
  deleteLiveSchedule(id: String!): Boolean!
  getSprayMoneyCode(liveScheduleID: String!, username: String!, reference: String!, paymentProcessor: String!, sprays: [sprayInput!]!): sprayMoneyResponse!
  sprayMoney(sprayCode: String!, currency: Currency!, spray: [sprayInput!]!): Boolean!
  upgradeToLuxe(eventID: UUID!): Boolean!
  setForeignAccountDetails(args: foreignAccountDetails!): Boolean!
  updateForeignAccountDetails(args: foreignAccountDetails!): Boolean!
  deleteForeignAccountDetails(foreignAccountId: String!): Boolean!
  setUpStripePayment(eventID: String!): String!
  initiatePayment(args: initiatePaymentInput!): InitiatePaymentResponse!
  verifyTransaction(reference: String!): TransactionV1!
  payForSprayMoneyV1(payload: payForSprayMoneyRequest!): Boolean!
  transferToBank(input: transferFromWalletRequest): TransferResponse
  transferThatExceedsThreshold(otp: String!, eventID: Int!): TransferResponse
  verifySetPinRequest(otp: String!, phone: String!): String!
  setWalletPin(eventID: Int!, newPin: String!): String!
  initiateWalletPinReset(eventID: Int!): String!
  verifyPinResetOTP(eventID: Int!, otp: String!): String!
  resetWalletPin(eventID: Int!, passcode: String!, newPin: String!): String!
  GENERATE_ASOEBI_PAYMENT_METADATA(event_id: UUID!, input: AseobiPaymentMetadataRequest!): AsoebiPaymentMetaData!
  generateGiftPaymentMetadata(input: GiftPaymentMetadataRequest!): GiftPaymentMetaData!
  generateLuxePaymentMetadata(event_id: UUID!, currency: Currency!): LuxePaymentMetaData!
  generateInviteFeePaymentMetadata(event_id: UUID!, amount: Float!, currency: Currency!, channel: String!, count: Int!): InviteFeePaymentMetaData!
  generateSprayMoneyMetadata(input: SprayMoneyMetadataRequest!): SprayMoneyMetaData!
  generateInawoAssistantPaymentMetadata(event_id: UUID!): InawoAssistantPaymentMetaData!
  initiateLuxeCardPayment(email: String!): InitiateLuxeGiftCardPaymentResponse!
  redeemLuxeCard(code: String!, pin: String!, event_id: UUID!): Boolean!
  autoReserveTable(event_id: UUID!, event_part_id: UUID!, max_tables: Int!, max_seats_per_table: Int!): Boolean
  reserveTable(event_id: UUID!, event_part_id: UUID!, request: reservationRequest!): Boolean
  getAdminMagicLink(email: String!): String!
  authenticateAdminMagicLink(token: Int!): RegistryAdminLoginResponse!
  logoutAdminAccount: Boolean!
  approveRegistryDocument(document_id: UUID!): RegistryDocument!
  rejectRegistryDocument(document_id: UUID!, reason: String): RegistryDocument!
  reviewMarriageApplicationByAdmin(marriage_application_id: UUID!, registry_id: UUID!): MarriageApplication!
  setMarriageDateByAdmin(marriage_application_id: UUID!, new_time: Time!, registry_id: UUID!): MarriageApplication!
  createApplicantAccount(phone_number: String!, applicantType: ApplicantTypeEnum!): RegistryApplicant!
  createSpouseAccount(phone_number: String!, marriage_application_id: UUID!): RegistryApplicant!
  deleteApplicantAccount: Boolean!
  selectRegistryForMarriage(registry_id: UUID!, marriage_application_id: UUID!): MarriageApplication!
  changeMarriageRegistryDate(marriage_application_id: UUID!, new_time: Time!): MarriageApplication!
  payForMarriageRegistry(marriage_registry_id: UUID!, registry_package_id: UUID!, event_id: UUID!, callback_url: String!, applicant_type: ApplicantTypeEnum!): PaystackInitializePayment!
  verifyPayment(registry_payment_id: UUID!): MarriageApplication!
  getDocumentPreSignedURL(document_type_id: UUID!, marriage_registry_id: UUID!, mime_type: String!): PresignURLResponse!
  verifyDocumentUpload(filename: String!, document_type_id: UUID!, application_id: UUID!, marriage_application_id: UUID!): RegistryDocument!
  submitDocuments(marriage_application_id: UUID!): SubmitDocumentsResponse!
  trackMeta(key: String!, value: String!): Boolean!
}

type PaginatedAlbum {
  page: Int!
  pageSize: Int!
  pageCount: Int!
  recordCount: Int!
  data: [Album!]!
}

type PaginatedAlbumMedia {
  page: Int!
  pageSize: Int!
  pageCount: Int!
  recordCount: Int!
  data: [AlbumMedia!]!
}

type PaginatedAuditLogs {
  page: Int!
  page_size: Int!
  page_count: Int!
  record_count: Int!
  data: [AuditLog!]!
}

type PaginatedFAQs {
  page: Int!
  pageSize: Int!
  pageCount: Int!
  recordCount: Int!
  data: [FAQ!]!
}

type PaginatedLiveComments {
  page: Int!
  pageSize: Int!
  pageCount: Int!
  recordCount: Int!
  data: [LiveComment!]!
}

type PaginatedLiveSchedule {
  page: Int!
  pageSize: Int!
  pageCount: Int!
  recordCount: Int!
  data: [LiveSchedule!]!
}

type Pagination {
  next: String
  back: String
}

scalar Password

input payForCashGiftRequest {
  """reference from paystack"""
  reference: String!

  """usd/ngn this is necessary to select the wallet to credit"""
  currency: Currency!

  """id of the event, please oo! this has to be correct"""
  eventID: Int!
  amount: Float

  """pending | failed => false or successful => true"""
  status: Boolean

  """first_name [other_name] last_name"""
  fullName: String

  """phone number of the person paying e.g +2349045057268"""
  phone: String

  """email of the person paying e.g hello@inawo.com"""
  email: String

  """an alias for the creditor, can be any string"""
  creditorAlias: String

  """payment processor either monnify, paystack, flutterwave"""
  paymentProcessor: paymentProcessor!
}

input payForSprayMoneyRequest {
  """reference from paystack"""
  reference: String!

  """USD/NGN"""
  currency: Currency!

  """id of the event, please oo! this has to be correct"""
  event_id: Int!

  """the amount paid in kobo/cent depending on the currency"""
  amount: Float!

  """the units to be sprayed"""
  units: String!

  """pending | failed => false or successful => true"""
  status: Boolean!

  """first_name [other_name] last_name"""
  full_name: String!

  """phone number of the person paying e.g +2349045057268"""
  phone: E164

  """email of the person paying e.g hello@inawo.com"""
  email: Email!

  """payment processor either monnify, paystack, flutterwave"""
  paymentProcessor: paymentProcessor!
}

input payForWishlistItemRequest {
  """USD/NGN"""
  currency: Currency!

  """wish list item id"""
  itemId: String!

  """name of the wish list item"""
  itemName: String!

  """reference from paystack"""
  reference: String!

  """id of the event, please oo! this has to be correct"""
  event_id: Int!

  """amount in the base units e.g kobo or cents"""
  amount: Float!

  """pending | failed => false or successful => true"""
  status: Boolean!

  """first_name [other_name] last_name"""
  full_name: String!

  """phone number of the person paying e.g +2349045057268"""
  phone: E164

  """email of the person paying e.g hello@inawo.com"""
  email: Email!

  """an alias for the creditor, can be any string"""
  creditorAlias: String

  """payment processor either monnify, paystack, flutterwave"""
  paymentProcessor: paymentProcessor!
}

type PaymentMetaDataCustomField {
  display_name: String!
  variable_name: String!
  value: String!
}

enum paymentProcessor {
  monnify
  paystack
  stripe
  flutterwave
}

enum PaymentStatusEnum {
  PENDING
  SUCCESSFUL
  FAILED
}

type PayStackBankData {
  name: String
  slug: String
  code: String
  longcode: String
  gateway: String
  pay_with_bank: Boolean
  active: Boolean
  is_deleted: Boolean
  country: String
  currency: String
  type: String
  id: Int
  createdAt: Time
  updatedAt: Time
}

type PayStackBanks {
  status: Boolean
  message: String
  data: [PayStackBankData]
  meta: Meta
}

type PaystackInitializePayment {
  authorization_url: String
  access_code: String
  Reference: String
}

type Pov {
  uploader: Creator!
  total_likes: Int!
  total_media_count: Int!
  total_videos: Int!
  total_pictures: Int!
  media: [AlbumMedia!]!
}

type PresignURLResponse {
  upload_url: String!
  file_name: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
}

type Query {
  health: Boolean!

  """deprecated"""
  refresh(refresh_token: String!): AuthResponse!
  refreshV2(refreshToken: String!): AuthResponse!
  user: User
  kyc: KYCRecord
  dojahBankList: [DojahBankInfo!]
  myDomains: DomainListResponse!
  domain(id: UUID!): Domain
  eventDomain(event_id: UUID!): Domain
  domainPricing(tld: String!): DomainPricing!
  domainHistory(domain_id: UUID!): [DomainHistory!]!
  checkEventSlug(slug: String!): Boolean!
  event(event_id: Int!): Event
  eventByUUID(event_uuid: String!): Event
  eventBySlug(slug: String!): Event
  events(isInvited: Boolean, page: Int, pageSize: Int): [Event]!
  getEventType: [EventType!]!
  findAvailableTemplates: [EventTemplates!]!
  guestCategory(event_id: Int!): [Category!]!
  guestCategoryById(event_id: Int!, categoryId: Int!): Category!
  noGuestPerCategory(event_id: Int!): [GuestPerCategory]!
  owners(event_id: Int!): [EventOwner!]!
  eventVendor(event_id: Int!, page: Int, pageSize: Int): [EventVendor]!
  getTeamMember(event_id: Int!): [EventOwner!]!
  ownerTypes: [String!]!
  invitationList(event_id: Int!, page: Int, pageSize: Int): [InvitationList!]!
  invitationList2(event_id: Int!, page: Int, pageSize: Int): InvitationListResponse
  filterInvitationListBy(event_id: Int!, filter: invitationListFilter!, page: Int!, pageSize: Int!): [InvitationList]
  filterInvitationListBy2(event_id: Int!, filter: invitationListFilter!, page: Int!, pageSize: Int!): InvitationListResponse
  filterInvitationListByCheckIn(event_id: UUID!, page: Int, pageSize: Int): InvitationListResponse!
  invitationCard(event_id: Int!): InvitationCard
  invitationCardTemplates: [INVITATION_CARD_TEMPLATE!]!
  invitationListByCategory(event_id: Int!, categoryId: Int, page: Int, pageSize: Int): [InvitationList!]!
  invitationListByCategory2(event_id: Int!, categoryId: Int, page: Int, pageSize: Int): InvitationListResponse
  invitationListBySearch(event_id: Int!, searchTerm: String, page: Int, pageSize: Int): [InvitationList!]!
  invitationListBySearch2(event_id: Int!, searchTerm: String, page: Int, pageSize: Int): InvitationListResponse
  invitationListByRSVPStatus(event_id: Int!, rsvpStatus: InvitationListRsvpStatus!, page: Int, pageSize: Int): [InvitationList!]!
  invitationListByRSVPStatus2(event_id: Int!, rsvpStatus: InvitationListRsvpStatus!, page: Int, pageSize: Int): InvitationListResponse
  event_preferences(event_id: UUID!): EventPreference!
  eventParts(event_id: Int!): [EventPart!]!
  getApprovedMessages(event_id: Int!, page: Int, pageSize: Int): [Message]
  getMessagesByEvent(event_id: Int!, page: Int, pageSize: Int): [Message]
  getMessagesByEventV1(event_id: Int!, page: Int, pageSize: Int): MessageResponse
  getMessageByUser(event_id: Int!, page: Int, pageSize: Int): [Message]
  getWishListItems(event_id: Int!, listId: Int, page: Int, pageSize: Int): [WishListItem]
  getPaidWishListItems(event_id: Int!, listId: Int, page: Int, pageSize: Int): [WishListItem]
  getBackStory(event_id: Int!): [BackStory]
  getWeddingParty(event_id: UUID!): [WeddingParty]
  getEventPlan(event_id: Int!): EventPlan!
  getCustomMyPlanTask(event_id: Int!): [EventTask]!
  getInvitedGuest(token: String!): InvitationList!
  getGeneralInviteToken(event_id: UUID!): String!
  getEventDetailsWithToken(event_token: String!): GeneralInvitationResp
  getHeroImage(event_id: Int!): String!
  GET_INAWO_PASS_PROGRESS(event_id: UUID!): InawoPassProgress!
  getAseobi(event_id: UUID!): [Aseobi!]
  getAseobiAttires(event_id: UUID!, aseobi_id: UUID!): [AseobiAttire!]
  getAseobiOrders(event_id: UUID!, aseobi_id: UUID, aseobi_attire_id: UUID): [AseobiOrder!]
  getFAQ(id: UUID!): FAQ
  getFAQsByEvent(event_id: UUID!, filter: FAQFilter!): PaginatedFAQs!

  """return all the tags a user can use"""
  getMediaTags: [AlbumMediaTag!]!
  getMedia(event_id: String!, filter: MediaFilter!): [AlbumMedia]
  getPov(event_id: String!): [Pov!]!
  getAlbums(event_id: String!): PaginatedAlbum!
  helloLiveVisitors: Boolean!

  """STREAMERS"""
  getEventStreamers(eventId: Int!): [Streamer]
  fetchStream(key: String!): StreamingChannel!
  is_streamer(args: IsStreamerInput!): Boolean
  getLiveSchedule(eventUuid: String!, page: Int, pageSize: Int): PaginatedLiveSchedule!
  getSpraysLeft(sprayCode: String!): [spray!]!
  getLiveComments(eventUuid: String!, page: Int, pageSize: Int): PaginatedLiveComments!

  """
  returns a list of available currencies with their name, symbol and slug(currency)
  """
  currency: [AvailableCurrency]!
  getWallets(event_id: UUID!): [Wallet]!
  getWalletByCurrency(event_id: Int!, currency: Currency!): Wallet
  getWishlistHistory(event_id: UUID!, page: Int!, page_size: Int): [WishListHistory]!
  getGiftHistory(event_id: UUID!, cursor: String, page_size: Int): GiftsWithPagination
  getForeignAccountSupportedCurrencies(event_id: UUID!): [AvailableCurrency!]!
  getBeneficiaries(wallet_id: String!): [Beneficiary!]
  getBanksWithRave(country: String!): [Bank]!
  RESOLVE_ACCOUNT_WITH_RAVE(account_number: String!, account_bank: String!): Account
  getForeignAccountDetails(event_id: Int!): [AccountDetails]!
  refreshCreditTransactionStatus(reference: String!): Boolean!
  describeLuxe(event_id: UUID!): LuxeDescription!
  DESCRIBE_ASEOBI_FEE_PERCENTAGE(eventID: UUID!): Float!
  validateLuxeCard(code: String!): Boolean!
  getTableReservations(event_id: UUID!, event_part_id: UUID, table_id: String): [TableReservation!]
  getRegistryAdmin(admin_id: UUID!): RegistryAdmin!
  getAdminByPhone(phone: String!): RegistryAdmin!
  getCurrentAdmin: RegistryAdmin!
  GetRegistryAgents(registry_id: UUID!, admin_id: UUID!): RegistryAgents!
  getAdminRegistries: [RegistryAgents]!
  getRegistryAdmins(registry_id: UUID!): [RegistryAgents]!
  getApplicantByAdmin(applicant_id: UUID!): RegistryApplicant!
  getMarriageApplicationByAdmin(marriage_registry_id: UUID!, registry_id: UUID!): MarriageApplication!
  getMarriageApplicationsByAdmin(registry_id: UUID!, filter: MarriageApplicationFilter!): [MarriageApplication]!
  getDocumentByAdmin(document_id: UUID!): RegistryDocument!
  getDocumentsByAdmin(marriage_application_id: UUID!, registry_id: UUID!): [RegistryDocument]!
  getRegistry(registry_id: UUID!): Registry!
  getRegistries(filter: RegistryFilter!): [Registry]!
  getDocumentType(document_type_id: UUID!): RegistryDocumentType!
  getDocumentTypes(registry_id: UUID!): [RegistryDocumentType]!
  getApplicantByPhone(phone: String!): RegistryApplicant!
  getSpouse(marriage_application_id: UUID!): RegistryApplicant!
  getCurrentApplicant: RegistryApplicant!
  getMarriageApplicationByApplicant(marriage_registry_id: UUID!): MarriageApplication!
  getMarriageApplicationsByApplicant(filter: MarriageApplicationFilter!): [MarriageApplication]!
  getDocumentByApplicant(document_id: UUID!): RegistryDocument!
  getDocumentsByApplicant(marriage_application_id: UUID!): [RegistryDocument]!
  getMarriageRegistryPaymentByApplicant(marriage_application_id: UUID!, filter: RegistryPaymentHistoryFilter!): RegistryPaymentHistory!
  getMarriageRegistryPaymentsByApplicant(marriage_application_id: UUID!, filter: RegistryPaymentHistoryFilter!): [RegistryPaymentHistory]!
  getMarriageRegistryPaymentByAdmin(registry_payment_id: UUID!, registry_id: UUID!): RegistryPaymentHistory!
  getMarriageRegistryPaymentsByAdmin(registry_id: UUID!, filter: RegistryPaymentHistoryFilter!): [RegistryPaymentHistory]!
  getRegistryPackage(registry_package_id: UUID!, registry_id: UUID!): RegistryPackages!
  getRegistryPackages(registry_id: UUID!): [RegistryPackages]!
  getTrackMeta(key: String!): String!
}

input RegisterDomainInput {
  domain_name: String!
  event_id: UUID!
  years: Int!
  auto_renew: Boolean
  contact: DomainContactInput!
}

type Registry {
  id: UUID!
  name: String!
  address: String!
  city: String!
  state: String!
  country: String!
  phone_numbers: [String!]!
  images: [String]!
  emails: [String!]!
  created_by_id: UUID!
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

type RegistryAdmin {
  id: UUID!
  first_name: String!
  last_name: String!
  email: String!
  phone_number: String!
}

type RegistryAdminLoginResponse {
  token: String!
  admin: RegistryAdmin!
  registry: [Registry!]!
}

enum RegistryAdminTypeEnum {
  SUPER_ADMIN
  ADMIN
}

type RegistryAgents {
  id: UUID!
  registry_id: UUID!
  admin_id: UUID!
  admin_type: RegistryAdminTypeEnum!
  status: RegistryAgentsStatusEnum!
  accepted_at: Time
  rejected_at: Time
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

enum RegistryAgentsStatusEnum {
  PENDING
  ACCEPTED
  REJECTED
  SUBMITTED
}

type RegistryApplicant {
  id: UUID!
  user_id: UUID!
  first_name: String!
  last_name: String!
  email: String!
  phone_number: String!
  deleted_at: Time
  created_at: Time!
  updated_at: Time
}

type RegistryDocument {
  id: UUID!
  document_type_id: UUID!
  document_type: RegistryDocumentType!
  marriage_application_id: UUID!
  url: String!
  approved_at: Time
  rejected_at: Time
  status: DocumentStatusEnum!
  approved_by_id: UUID
  reason: String
  rejected_by_id: UUID
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

type RegistryDocumentType {
  id: UUID!
  name: String!
  description: String!
  stage: Int!
  required: Boolean!
  applicant_type: ApplicantTypeEnum!
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

input RegistryFilter {
  id: UUID
  name: String
  address: String
  city: String
  state: String
  country: String
}

type RegistryPackages {
  id: UUID!
  registry_id: UUID!
  name: String!
  type: RegistryPaymentTypeEnum!
  description: String!
  currency: Currency!
  venue_type: RegistryPackageVenueTypeEnum!
  registration_fee: Float!
  processing_fee: Float!
  service_fee: Float!
  total_fee: Float!
  properties: [String!]!
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

enum RegistryPackageVenueTypeEnum {
  COURTHOUSE
  OFFSITE
}

type RegistryPaymentHistory {
  id: UUID!
  marriage_registry_id: UUID!
  registry_package_id: UUID!
  type: RegistryPaymentTypeEnum!
  currency: Currency!
  amount: Float!
  status: PaymentStatusEnum!
  created_at: Time!
  updated_at: Time
  deleted_at: Time
}

input RegistryPaymentHistoryFilter {
  used: Boolean
  status: PaymentStatusEnum
  type: RegistryPaymentTypeEnum
}

enum RegistryPaymentTypeEnum {
  NEW_REGISTRY
  CHANGE_REGISTRY_DATE
}

input reservationRequest {
  arrangements: [guestArrangement!]!
}

type ResourceCount {
  resource: AuditResource!
  count: Int!
}

type RSVP {
  id: Int!
  event_id: Int!
  invitation_list_id: Int!
  field: String!
  value: String
  created_at: Time!
  updated_at: Time
}

type RSVPQuestion {
  id: Int!
  event_id: Int!
  invitation_id: Int!
  question: String!
  question_type: String
  status: Boolean!
  created_at: Time!
  updated_at: Time
}

input rsvpResp {
  id: Int!
  event_id: Int!
  invitation_list_id: Int!
  field: String!
  value: String
}

input SelectTemplateReq {
  event_id: UUID!
  template_id: String!
}

type SelfiePresignURLResponse {
  upload_url: String!
  file_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
  invitation_id: UUID!
}

type SendInvitationResponse {
  id: Int!
  error: String!
}

type SendInvitationResponseStatus {
  id: String!
  error: String
}

type SendInvitationsResponse {
  channel: String!
  status: [SendInvitationResponseStatus!]!
}

input SendInviteReq {
  pending: Boolean!
  all: Boolean!
  channel: Channel!
  list_id: [String!]!
}

input SignUpRequest {
  phone_number: String!
  email: Email!
  password: Password!
  first_name: String!
  last_name: String!
  other_name: String
  title: String
  gender: Gender
}

type spray {
  unit_value: Float!
  units: Int!
}

input sprayInput {
  units: Int!
  unit_value: Float!
}

type SprayMoneyMetaData {
  inawo_product: String!
  event_id: UUID!
  spray_id: UUID!
  live_schedule_id: UUID!
  user_id: UUID
  username: String!
  full_name: String
  contact_email: String
  contact_phone_number: String
  payment_reference: String!
  payment_provider: String!
  sub_account_id: String!
  sub_account_code: String!
  currency_iso: String!
  split_percentage: Float!
  sprays: [spray!]!
  total_units: Int!
  amount: Float!
  hash: String!
  timestamp: Time!
  custom_fields: [PaymentMetaDataCustomField!]!
}

input SprayMoneyMetadataRequest {
  payment_provider: String!
  user_id: UUID
  event_id: UUID!
  live_schedule_id: UUID!
  username: String!
  contact_email: String
  contact_phone: String
  full_name: String
  currency: Currency!
  sprays: [sprayInput!]!
  total_units: Int!
  amount: Float!
}

type sprayMoneyResponse {
  spray_code: String!
  amount: Float!
  units: Int!
  currency: Currency!
  reference: String!
  payment_processor: paymentProcessor!
  created_at: Time!
}

type StreamDetails {
  Id: String!
  eventId: Int!
  stream_url: String!
  deviceName: String!
}

type Streamer {
  Id: String!
  event: Event!
  event_uuid: String!
  is_streaming: Boolean!
  playback_url: String!
  ingest_endpoint: String!
  stream_key: String!
  deviceName: String!
  viewingUrl: String!
  created_at: String!
}

type StreamingChannel {
  Id: String!
  ingest_endpoint: String!
  stream_key: String!
  event: Event!
}

type StripeConnectOnboardingResponse {
  status: String!
  account_id: String!
  onboard_url: String!
}

type StripeConnectStatusResponse {
  status: String!
  is_connected: Boolean!
  account_id: String
  charges_enabled: Boolean!
  payouts_enabled: Boolean!
  requirements_due: [String!]
  error: String
}

type SubmitDocumentsResponse {
  success: Boolean!
  message: String
}

type Subscription {
  userGreeted: String!
  getRecentSpray(liveScheduleID: String!): LiveSprayEvent!
  getRecentComments(liveScheduleID: String!): LiveCommentEvent!
}

type TableReservation {
  id: UUID!
  invitation_id: UUID!
  event_id: UUID!
  event_part_id: UUID!
  table_id: String!
  seat: String!
  slot: Int!
  guest_info: TableReservationGuestInfo!
}

type TableReservationGuestInfo {
  first_name: String!
  last_name: String
  phone: String
  email: String
  title: String
  is_slot: Boolean!
}

input TeamMember {
  event_id: Int!
  first_name: String!
  last_name: String!
  other_name: String
  title: String
  email: String
  phone_number: String!
  role: EventOwnerRole!
}

scalar Time

type TransactionMetadata {
  user_id: String
  creditor_alias: String
  item_id: String
  item_name: String
  phone_number: String
  email: String
  bank_account_number: String
  bank_name: String
  account_name: String
  charges: Float
  amount_sent: Float
  amount: Float!
  date: Time!
  event_id: Int!
  payment_processor_reference: String!
  payment_processor: String!
  transaction_type: String!
  currency: String!
  description: String!
}

enum TransactionTypeEnum {
  credit
  debit
  all
  last
}

type TransactionV1 {
  """used for indexing"""
  id: UUID!

  """reference -> very important (takes precedence over the id)"""
  reference: String!

  """e.g paystack, monnify, stripe, flutterwave ... (all lower case)"""
  payment_processor: String!

  """provides context of transaction"""
  description: String!

  """narration for the transaction"""
  narration: String!

  """the id of the event for which the transaction was made"""
  event_uuid: UUID!
  event_id: Int!

  """if the transaction was made by an authenticated user"""
  user_uuid: UUID

  """anonymous or the person's name"""
  full_name: String

  """returns if the transaction was made by an authorized user"""
  user: User

  """a uuid string representing the wallet id"""
  wallet_id: UUID!

  """deprecated -> same as virtual bank account number"""
  wallet_code: String

  """for now [ USD | NGN ] ...all caps (upper case)"""
  currency: Currency!

  """in kobo/cent depending on currency e.g N100 -> 10,000 & $12 -> 1,200"""
  amount: Float!

  """
  true|false (a summary of the stage of the transaction) ==>
  
  stage:successful-> true
  &
  stage:failed -> false
  """
  status: String!

  """[ successful | failed | pending ] ... (all lower case)"""
  stage: String!

  """[ credit | debit ] ... (all lower case)"""
  type: String!

  """only provided if the transaction was for payment of a wishlist item"""
  item_id: String
  metadata: TransactionMetadata!

  """gift, gift-fee, withdraw, withdraw-fee"""
  kind: String!

  """time the transaction was done"""
  created_at: Time

  """last update at"""
  updated_at: Time
}

type TransactionWithPagination {
  meta: Pagination
  transaction: [TransactionV1]
}

input transferFromWalletRequest {
  currency: Currency!
  event_id: Int!
  walletId: String!
  amount: Float!
  accountNumber: String!
  accountBank: String!
  accountName: String
  narration: String
  bankCode: String!
  reference: String!
  walletPin: String!
}

type TransferResponse {
  status: Boolean!
  otp_is_required: Boolean!
}

input updateBackStoryReq {
  id: Int!
  role: BackStoryRole
  title: String
  image: String
  story: String
}

input UpdateBankDetailsRequest {
  account_number: String!
  bank_code: String!
  currency: Currency!
  bvn: String
}

input updateDocumentTypeInput {
  name: String
  description: String
  stage: Int
  applicant_type: ApplicantTypeEnum
}

input UpdateEventPartRequest {
  id: Int!
  event_id: Int!
  time: String
  name: String
  part: String
  welcome_msg: String
  address: String
  city: String
  state: String
  country: String
  image: String
  geo_position: GeoPositionInput
  programs: [EventPartProgramInput]
}

input UpdateEventPreferenceRequest {
  event_id: UUID!
  food: Boolean
  ads: Boolean
  asoebi_selection: Boolean
  gifts: Boolean
  store: Boolean
  access_control: Boolean
  vendor_store: Boolean
  reservation: Boolean
  smart_send: Boolean
  dress_code: Boolean
  map: Boolean
  private: Boolean
  live_hall: Boolean
}

input UpdateEventSettingRequest {
  id: Int
  event_id: Int!
}

input UpdateEventVendorRequest {
  id: Int!
  event_id: Int!
  name: String
  role: String
  image: String
  facebook: String
  twitter: String
  email: String
  instagram_handle: String
  phone_number: String
}

input UpdateFAQInput {
  id: UUID!
  event_id: UUID!
  event_part_id: UUID
  question: String
  answer: String
  order_index: Int
  is_active: Boolean
}

input UpdateInviteListReq {
  id: Int!
  first_name: String
  last_name: String
  other_name: String
  title: String
  phone: String
  category_id: Int
  email: String
  slots: Int
}

input UpdateMessageStatusReq {
  message_id: Int!
  status: Boolean!
}

input updateRegistryInput {
  name: String
  address: String
  city: String
  state: String
  phone_numbers: [String!]
  images: [String!]
  emails: [String!]
}

input UPDATE_STREAMER {
  inviteListId: Int!
  eventId: Int!
  streamer_name: String!
  streamer_email: String
  streamer_phone: String!
}

input UpdateUserDetailsRequest {
  image: String
  age: Int
  languages: [String]
  address: String
  city: String
  state: String
  Country: String
}

input UpdateUserPreferenceRequest {
  field: String!
  value: String!
}

input UpdateUserProfileRequest {
  image: String
  first_name: String
  other_name: String
  last_name: String
  email: String
  phone_number: String
}

input updateWeddingPartyReq {
  id: UUID!
  first_name: String
  last_name: String
  nickname: String
  role: String
  image_url: String
  story: String
  order_index: Float
}

"""Users on Inawo"""
type User {
  id: Int!
  uuid: UUID!
  email: Email
  first_name: String!
  image: String
  last_name: String
  other_name: String
  title: String
  gender: Gender
  phone_number: String!
  verified: Boolean!
  guest: Boolean
  created_at: Time
  updated_at: Time
  lastLoggedInAt: Time
  kyc_record: KYCRecord
}

type UserActivity {
  user_id: UUID!
  user_email: String!
  user_name: String!
  action_count: Int!
  last_activity: Time!
}

type UserInfo {
  user_id: UUID
  full_name: String!
  email: String!
  phone_number: String!
}

enum UserTypeEnum {
  admin
  guest
}

scalar UUID

type Wallet {
  id: UUID!
  event_id: UUID!
  currency: Currency!
  status: WalletStatus!
  balance: Float!
  payment_provider: String
  gift_volume: Float!
  pin_is_set: Boolean!
  frozen: Boolean!
  created_at: Time
  updated_at: Time
}

enum WalletStatus {
  pending
  verified
  paused
  suspended
}

type WalletSubAccount {
  wallet_id: UUID!
  currency: Currency!
  provider: String!
  subaccount_id: String!
  subaccount_code: String!
}

input WalletUser {
  id: Int!
  uuid: UUID
  email: Email

  """first name of the person"""
  first_name: String!
  image: String

  """last name of the person"""
  last_name: String
  other_name: String
  title: String

  """gender of the person"""
  gender: Gender

  """phone number of the person"""
  phone: String!
}

type WeddingParty {
  id: UUID!
  event_id: UUID!
  first_name: String!
  last_name: String!
  nickname: String
  role: String!
  image_url: String
  story: String
  order_index: Float
  created_at: Time
  updated_at: Time
}

type WeddingPartyPresignedURLResponse {
  upload_url: String!
  file_uri: String!
  expiry_time: Time!
  expiry_time_in_seconds: Int!
  event_id: UUID!
}

type WishListHistory {
  gift_id: UUID!
  wallet_id: UUID!
  currency: Currency!
  amount: Float!
  wish_list_item_id: UUID!
  wish_list_item: WishListItem!
  appreciated: Boolean!
  user: UserInfo
}

type WishListItem {
  id: Int!
  uuid: UUID
  wish_list_id: Int
  event_id: Int!
  name: String
  image: String
  amount: Float
  currency: String
  paid: Boolean
  paid_by: Int
  user: User
  qty: Int
  appreciation: String
  created_at: Time
  updated_at: Time
}
`;
